// Modül seviyesinde status emitter köprüsü.
// ChatContext bağlı socket'in emit fonksiyonunu buraya kaydeder; böylece
// herhangi bir dosya (modal, alt-bileşen) React hook'una ihtiyaç duymadan
// statü değişimi yayınlayabilir.
let _emit = null;

export function setStatusEmitter(fn) {
  _emit = typeof fn === "function" ? fn : null;
}

// data: { entity: "operation"|"offer"|"request"|"user", id, ...extra }
// id VERİLMEZSE "*" (liste düzeyi / toplu yenile) olarak yayınlanır: bazı çağrı noktaları
// (depo çıkışı, oda gruplama, snapshot güncelleme) API yanıtında id gelmediğinde bilinçli
// olarak id'siz yayın yapıyor; eski guard bu sinyalleri sessizce yutuyordu.
export function emitStatusUpdate(data) {
  if (!_emit || !data || !data.entity) return;
  const payload = data.id != null ? data : { ...data, id: "*" };
  try { _emit(payload); } catch (e) { /* sessizce geç */ }
}
